<template>
  <div v-loading="loading">
    <el-form
      :inline="true"
      :model="calculateForm"
      :rules="calculateRule"
      size="small"
      ref="calculateFormRef"
      label-width="100px"
    >
      <el-form-item label="租赁车辆数" prop="carNum">
        <el-input v-model="calculateForm.carNum" placeholder="请输入车辆数"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="calculate">盈收测算</el-button>
      </el-form-item>
    </el-form>
    <div class="text-12 table-info">费用信息需按照租赁 1 辆车单月成本/收入维度填写</div>
    <planTable
      :schema="editSchema"
      :defaultPlans="defaultEditPlans"
      :leaseType="leaseType"
      :plans.sync="editPlans"
      :editable="true"
    />
    <el-drawer
      title="测算结果"
      :visible.sync="showResult"
      :wrapperClosable="true"
      :append-to-body="true"
      :destory-on-close="true"
      size="85%"
    >
      <div class="content" v-loading="previewLoading">
        <planTable
          :schema="previewSchema"
          :defaultPlans="defaultPreviewPlans"
          :editable="false"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import planTable from './components/planTable.vue'
// eslint-disable-next-line import/no-cycle
import { getSchema, calculate } from '@/api/carResource/index'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    planTable,
  },
  data() {
    // 自定义校验规则
    const validateCarNum = (rule, value, callback) => {
      const num = Number(value)
      if (/\D/g.test(value) || num > 1000 || num < 1) {
        callback(new Error('请输入1~1000的整数'))
      } else {
        callback()
      }
    }
    return {
      // 编辑态schema
      editSchema: [],
      // 预览态schema
      previewSchema: [],
      // 测算表单
      calculateForm: {
        carNum: 1,
      },
      // 校验车辆数规则
      calculateRule: {
        carNum: [{ required: true, validator: validateCarNum, trigger: 'change' }],
      },
      // 默认方案
      defaultEditPlans: [{}, {}, {}, {}],
      // 编辑好的展示数据
      editPlans: [],
      // 预览数据
      defaultPreviewPlans: [],
      // 展示测算结果弹窗
      showResult: false,
      // 方案类型：
      leaseType: Number(this.$route.query.leaseType),
      // 全屏加载
      loading: false,
      // 预览加载
      previewLoading: false,
    }
  },
  methods: {
    // 盈收测算
    calculate() {
      this.$refs.calculateFormRef.validate((valid) => {
        if (valid) {
          // 出租率不能为0
          const rentRate = this.editPlans.find((item) => item.code === 'ITEM_22')
          if (rentRate) {
            for (const i in rentRate) {
              if (Object.hasOwnProperty.call(rentRate, i) && i.indexOf('plan-') === 0 && rentRate[i] === '0') {
                this.$message.warning('出租率不能为0')
                return
              }
            }
          }
          this.previewLoading = true
          const params = this.model2params()
          calculate({
            carNum: this.calculateForm.carNum,
            programmeList: params,
          }).then((res) => {
            if (res?.code === 1) {
              this.defaultPreviewPlans = res?.data?.programmeList
            }
          }).finally(() => {
            this.previewLoading = false
          })
          this.showResult = true
        }
      })
    },
    // 过滤数据转换参数
    model2params() {
      // 先提取Object，再转为Array
      const plans = {}
      const result = []
      this.editPlans.forEach((item) => {
        if (item.editable) {
          // 找到以plan-开头的属性，其值就是用户填写的数据
          for (const i in item) {
            if (Object.hasOwnProperty.call(item, i) && i.startsWith('plan-')) {
              const configItem = {
                code: item.code,
                amountString: item[i],
              }
              if (plans[i]) {
                plans[i].push(configItem)
              } else {
                plans[i] = [configItem]
              }
            }
          }
        }
      })
      Object.keys(plans).sort().forEach((item) => {
        const planId = item.split('-')[2]
        result.push({
          programmeId: planId,
          itemList: plans[item],
        })
      })
      return result
    },
  },
  created() {
    this.loading = true
    getSchema({ leaseType: Number(this.leaseType) }).then((res) => {
      if (res.code === 1) {
        this.previewSchema = res.data
        const editableCodeArr = []
        const editableSchema = cloneDeep(res.data.filter((item) => {
          // GP_4作为经营收益在编辑态不展示
          const result = item.groupCode !== 'GP_4' && (item.editable || !item.code)
          if (result && item.editable && !editableCodeArr.includes(item.subGroupCode)) {
            editableCodeArr.push(item.subGroupCode)
          }
          return result
        }))
        // 过滤掉subGroupCode下全部不可编辑的
        this.editSchema = editableSchema.filter((item) => {
          return editableCodeArr.includes(item.subGroupCode)
        })
        calculate({
          carNum: 1,
          programmeList: [{ programmeId: this.$route.query.id }],
        }).then((r) => {
          if (r.code === 1) {
            this.$set(this.defaultEditPlans, 0, r.data.programmeList[0])
          }
        }).finally(() => {
          this.loading = false
        })
      }
    })
  },
}
</script>
<style scoped lang="scss">
.content{
  padding: 0px 10px;
}
.table-info {
  margin-bottom: 16px;
}
::v-deep .gray-bg {
  background-color: #F7F8FA;
}

::v-deep .overflow-hidden {
  overflow: hidden;
}

::v-deep .white-bg {
  background-color: #fff !important;
}

::v-deep .gray-border {
  border: solid 1px #EBEDF0 !important;

  .cell {
    overflow: hidden;
  }
}

::v-deep .gray-border-left {
  border-top: solid 1px #EBEDF0 !important;
  border-left: solid 1px #EBEDF0 !important;
}

::v-deep .gray-border-right {
  border-top: solid 1px #EBEDF0 !important;
  border-right: solid 1px #EBEDF0 !important;
}

.plan-column-header {
  position: relative;

  .QS-icon-close {
    position: absolute;
    top: 0;
    right: -6px;
  }

  .plan-column-header-name {
    padding: 0 8px;
  }
}
</style>
